import { render, staticRenderFns } from "./headerBlack.vue?vue&type=template&id=b0d027ba&scoped=true&"
import script from "./headerBlack.vue?vue&type=script&lang=js&"
export * from "./headerBlack.vue?vue&type=script&lang=js&"
import style0 from "./headerBlack.vue?vue&type=style&index=0&id=b0d027ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d027ba",
  null
  
)

export default component.exports